import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { CnLoading } from '@cainiaofe/cn-ui';

let loadingSetter;
function LoadingComp() {
  const [visible, setVisible] = useState(false);
  loadingSetter = setVisible;
  return (
    <span>
      <CnLoading visible={visible} fullScreen shape="fusion-reactor" />
    </span>
  );
}
let timer;
let loadingNode;
// 显示全局 loading
export const showLoading = (delay = 300, opt) => {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  loadingNode = document.createElement('div');
  loadingNode.setAttribute('id', 'full#loading');
  document.body.appendChild(loadingNode);
  timer = setTimeout(() => {
    ReactDOM.render(<LoadingComp />, document.getElementById('full#loading'));
    if (loadingSetter instanceof Function) loadingSetter(true);
  }, timer);
};
// 隐藏 loading
export const hideLoading = (opt) => {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  if (loadingSetter instanceof Function) loadingSetter(false);
};
